import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 bg-white rounded-lg" }
const _hoisted_2 = ["placeholder", "rows", "maxlength"]

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextareaInput',
  props: {
    modelValue: {},
    placeholder: {},
    rows: { default: 8 },
    maxlength: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const inputValue = ref(props.modelValue)

watch(inputValue, (val) => {
  emit('update:modelValue', val)
})

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== inputValue.value) {
      inputValue.value = newVal
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      placeholder: _ctx.placeholder,
      rows: _ctx.rows,
      maxlength: _ctx.maxlength,
      class: "rounded-md border-[1px] border-solid border-neutral50 p-2 w-full max-h-96 resize-y focus:outline-none focus:ring-1 focus:ring-primary30 focus:border-primary30 text-textPrimary"
    }, null, 8, _hoisted_2), [
      [_vModelText, inputValue.value]
    ])
  ]))
}
}

})